import React, { ReactNode } from "react";
import {
    Theme,
    WithStyles,
    Typography,
    StandardProps
} from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import createStyles from "@material-ui/core/styles/createStyles";
import { AppSelect, SimpleOption } from "js/react/components";
import { StyleClassKey } from "js/react/typescript";

const styles = (theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            alignItems: "center"
        }
    });

export type PerPageSelectorClassKey = StyleClassKey<typeof styles>;

export interface PerPageSelectorProps
    extends StandardProps<{}, PerPageSelectorClassKey> {
    selected?: number;
    before?: ReactNode;
    after?: ReactNode;
    allowed?: number[];
    onChange: (perPage: number) => void;
}

const decorator = withStyles(styles);

function Component({
    classes,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange = () => {},
    allowed = [5, 10, 25, 50, 100],
    before = <Typography>Show&nbsp;</Typography>,
    after = <Typography>&nbsp;entries</Typography>,
    ...rest
}: PerPageSelectorProps) {
    return (
        <div className={classes.root}>
            {before}
            <AppSelect
                value={{
                    label: rest.selected.toString(),
                    value: rest.selected
                }}
                isSearchable={false}
                onChange={(val: SimpleOption) => onChange(val.value)}
                options={allowed.map(item => ({
                    label: item.toString(),
                    value: item
                }))}
                menuPlacement={"top"}
                menuShouldScrollIntoView={true}
            />
            {after}
        </div>
    );
}

export const PerPageSelector = decorator(Component);
export default PerPageSelector;
